import { render, staticRenderFns } from "./LearningMaterials.vue?vue&type=template&id=a351591a&scoped=true"
import script from "./LearningMaterials.vue?vue&type=script&lang=ts"
export * from "./LearningMaterials.vue?vue&type=script&lang=ts"
import style0 from "./LearningMaterials.vue?vue&type=style&index=0&id=a351591a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a351591a",
  null
  
)

export default component.exports